import React, { Component } from 'react'
import { Card, CardHeader, CardBody, Alert, CardFooter, Button, } from 'reactstrap'
import PropTypes from 'prop-types'
import { Preview, HtmlEditor, PassageCard, ImageManagerOpenButton } from './'
import saveContentEdit from '../../../helpers/content/manageContent/saveContentEdit';
import TextEditor2 from '../../TextEditor/TextEditor2'
import getContent from '../../../helpers/content/manageContent/getContent';

class ContentCard extends Component {

  state = {
    content: this.props.content + '' || '',
    error: '',
    wysiwyg: false,
  }

  toggleWysiwyg = () => this.setState({wysiwyg: !this.state.wysiwyg})

  save = (contents) => {
    const { activeItemId, contentType } = this.props
    this.setState({content: contents})
    return saveContentEdit(contentType, activeItemId, contents)
  }

  render() {
    const { 
      activeEditor,
      openEditor,
      closeEditor,
      editorId,
      quillText,
      handleQuillChange,
      contentType,
      quillDesignator,
      loading,
      activeItem,
      query, } = this.props
    const { save, toggleWysiwyg } = this
    const { error, content, wysiwyg } = this.state
    const headers = {
      question: 'Question',
    }
    const header = headers[contentType]
    const previewContent = getContent(activeItem, quillDesignator)

    return (
      <Card>
        <CardHeader>
          <i className='icon-note icons font-1xl mt-2'></i>
          {header}
        </CardHeader>
        <CardBody className='card-body'>
          {activeEditor === contentType
            ? !wysiwyg
              ? <HtmlEditor
                  closeEditor={closeEditor}
                  save={save}
                  contents={previewContent}
                  loading={loading}
                  contentType={contentType}
                />
              : <TextEditor2
                  editorId={editorId}
                  quillText={quillText}
                  handleQuillChange={handleQuillChange}
                />
            : <Preview
                contents={previewContent}
                openEditor={() => openEditor(contentType, quillDesignator)}
                loading={loading}
                contentType={contentType}
              />
          }
          {error && <Alert>{error}</Alert>}
        </CardBody>
        <CardFooter>
          <Button onClick={toggleWysiwyg}>
            {wysiwyg
              ? 'Edit HTML'
              : 'Edit WYSIWYG'
            }
          </Button>
          {!wysiwyg &&
            <ImageManagerOpenButton query={query} />
          }
        </CardFooter>
      </Card>
    )
  }
}

ContentCard.propTypes = {
  content: PropTypes.string.isRequired,
  activeItemId: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  quillDesignator: PropTypes.object.isRequired,
  activeEditor: PropTypes.string.isRequired,
  openEditor: PropTypes.func.isRequired,
  closeEditor: PropTypes.func.isRequired,
  editorId: PropTypes.object.isRequired,
  quillText: PropTypes.string,
  handleQuillChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  activeItem: PropTypes.object.isRequired,
}

ContentCard.defaultProps = {
  content: '',
  loading: false,
}

export default ContentCard


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/ContentCard.js